import * as auth from 'js/redux/api/auth'
import * as user from 'js/redux/api/user'
import * as organisation from 'js/redux/api/organisation'
import * as article from 'js/redux/api/article'
import * as category from 'js/redux/api/category'
import * as dataset from 'js/redux/api/dataset'
import * as discovery from 'js/redux/api/discovery'
import * as fundings from 'js/redux/api/fundings'
import * as insight from 'js/redux/api/insight'
import * as search from 'js/redux/api/search'
import * as help from 'js/redux/api/help'
import * as site from 'js/redux/api/site'
import * as webpage from 'js/redux/api/webpage'
import * as tag from 'js/redux/api/tag'
import * as metrics from 'js/redux/api/metrics'
import * as carousel from 'js/redux/api/carousel'
import * as nprinting from 'js/redux/api/nprinting'
import { applyMiddleware, compose } from 'redux'
import thunkMiddleware from 'redux-thunk'
import history from './history'

export const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export default composeEnhancers(
  applyMiddleware(
    history,
    thunkMiddleware.withExtraArgument({
      article,
      auth,
      carousel,
      category,
      dataset,
      discovery,
      fundings,
      help,
      insight,
      metrics,
      organisation,
      search,
      nprinting,
      site,
      tag,
      user,
      webpage
    })
  )
)
